(function Module() {
    'use strict';

    mySynch.controller('FarmGoalManagementController', [
        '$scope',
        'MySynchFactory',
        'ViewAuthorizationFactory',
        'mySynchEnumerationService',
        'ApiFactory',
        'mySynchConstantService',
        'performanceMetricsService',
        'performanceContextService',
		'$q',
		'clientLoggerService',
        function FarmGoalManagementController($s, MSF,viewAuth,mySynchEnumSvc, api,mySynchConstSvc, perfMetricSvc, perfContextSvc, $q, log) {
            var defaultPersonTypeId = 6; // "Other"	

            $s.pageLoading = true;

            $s.hasUpdatePermission = false;
            $s.updatePermissionCode = 'FARM_GOAL_MANAGEMENT_UPDATE';

            $s.farmGoal = "";
            $s.actionItemGroups = [];
            $s.activeActionItemGroups = [];
            $s.completedActionItemGroups = [];
            $s.removedActionItemGroups = [];
            $s.displayRemovedActionItemGroups = [];
            $s.actionItems = [];

            $s.isEditingActionItemGroup = false;
            $s.isEditingActionItem = false;
            $s.currentActionItemGroup = {};
            $s.currentActionItem = {};
            $s.currentActionItemGroupRef = {};
            $s.currentActionItemRef = {};
            $s.actionItemGroupKeyFreeText = "";
            $s.currentFarmGoalData = {}; // farmId, farmGoal, userId
            $s.currentFarmGoalText = "";
            $s.people = [];
            $s.actionItemStatuses = [];
            $s.territoryManager = null;
            $s.activeHerd = angular.copy(MSF.getActiveHerd());
            $s.performanceContext = null;
            $s.dateFormat = "";

            
            $s.MSF = MSF;
            $s.loading = false;
            
            $s.farmGoalData = {};
      
            $s.isEditing = true;

            // the farm id of the farm that we are editing , but will be undefined if we are adding a new farm
            $s.farmId = null;
            $s.herdId = null;
            $s.herd = {};

            $s.codeFile = [];


            $s.actionItemGroupTmpl;
            $s.actionItemTmpl;

            

            var deregOnHerdChange = undefined;

          
            $s.isDateBeforeToday = function (date) {
                var today = moment();
                return today.isAfter(date);
            };

        
 

            $s.getAssociatedMetricsStringList = function getAssociatedMetricsStringList(metricsArray, fieldName, seperator) {
                var stringList = "";
                if (_.get(metricsArray, 'length') > 0) {

                    var fieldCodes = _.pluck(metricsArray, fieldName);
                    var dispalyValues = _.map(fieldCodes, function (metricCode) {
                        var displayMetricName = metricCode;
                        var metricCodeValue = _.get(_.find($s.codeFile, { codeType: "ACTIONITEMMETRIC", code: metricCode }), 'codeValue');
                        if (!_.isUndefined(metricCodeValue)) {
                            displayMetricName = metricCodeValue;
                        }
                        return displayMetricName;
                    });
                    if (_.get(dispalyValues, 'length') > 0) {
                        stringList = dispalyValues.join(seperator);
                    }

                }

                return stringList;
            };

            $s.onEditFarmGoal = function () {
                $s.currentFarmGoalText = $s.farmGoal;
                $s.toggleModal("farmGoalModal");
            };
            $s.onAddActionItemGroup = function onAddActionItemGroup() {

                $s.currentActionItemGroup = _.cloneDeep($s.actionItemGroupTmpl);


                _.set($s.currentActionItemGroup,"HerdId",_.get($s.activeHerd,'herdId',_.get($s.activeFarm,'herds[0].herdId')));
                
                $s.isEditingActionItemGroup = false;
                $s.toggleModal("actionItemGroupModal");
            };

            $s.onEditActionItemGroup = function onEditActionItemGroup(actionItemGroup) {
               
                $s.currentActionItemGroupRef = actionItemGroup;

                $s.currentActionItemGroup = _.cloneDeep(actionItemGroup);

        
                if (_.isEqual(_.get(actionItemGroup, 'ActionItemGroupKey'), "OTHER")) {
                    _.set($s.currentActionItemGroup, 'ActionItemGroupKeyFreeText', _.get(actionItemGroup, 'Description'));
                }


                $s.isEditingActionItemGroup = true;
           

                _.set($s.currentActionItemGroup, 'AssociatedMetrics', _.map(_.get($s.currentActionItemGroup, 'AssociatedMetrics'), function (metric) {
                    return _.get(metric, 'Metric');
                })
                );


                $s.toggleModal("actionItemGroupModal");
            };

            $s.onEditActionItem = function onEditActionItem(actionItem, actionItemGroup) {

                $s.isEditingActionItem = true;
                $s.currentActionItem = _.cloneDeep(actionItem);
                
              

                _.set($s.currentActionItem, 'Person', {
                    FarmId: _.get($s.currentActionItem, 'FarmId'),
                    PersonId: _.get($s.currentActionItem, 'PersonId'),
                    FirstName: _.get($s.currentActionItem, 'FirstName'),
                    LastName: _.get($s.currentActionItem, 'LastName'),
                    FullName: _.get($s.currentActionItem, 'FullName')

                });

                _.set($s.currentActionItem, 'DueDate', moment(_.get($s.currentActionItem, 'DueDate')).toDate());

                if(!_.isEqual(_.get($s.currentActionItem,'DateCompleted'),"") && !_.isNull(_.get($s.currentActionItem,'DateCompleted'))){
                    _.set($s.currentActionItem, 'DateCompleted', moment(_.get($s.currentActionItem, 'DateCompleted')).toDate());
                }
                if(!_.isEqual(_.get($s.currentActionItem,'DateRemoved'),"") && !_.isNull(_.get($s.currentActionItem,'DateRemoved'))){
                   _.set($s.currentActionItem, 'DateRemoved', moment(_.get($s.currentActionItem, 'DateRemoved')).toDate());
                }



                $s.currentActionItemRef = actionItem;
                $s.currentActionItemGroupRef = actionItemGroup;
                $s.toggleModal("actionItemModal");
            };

            $s.onAddActionItem = function onAddActionItem(actionItemGroup) {
               
                $s.currentActionItem = _.cloneDeep($s.actionItemTmpl);
                _.set($s.currentActionItem, 'Status', "NS");
                
                $s.currentActionItemGroupRef = actionItemGroup;
                $s.isEditingActionItem = false;

                $s.toggleModal("actionItemModal");
            };


            $s.onUndoRemovedActionItem = function onUndoRemovedActionItem(actionItem, actionItemGroup) {
            
                MSF.confirm({
                    title: 'Undo',
                    messageHeader: "Action Item: " + _.get(actionItem, 'Description',""),
                    message: "Are you sure you want to undo the removal of this Action Item?",
                    confirm: {
                        className: 'warning',
                        icon: 'undo',
                        text: "Undo"
                    }
                }, function confirmActionItemUndoRemoval() {
                    _.forEach($s.actionItemGroups, function (actionItemGrp) {
                        if (_.isEqual(_.get(actionItemGrp, 'GroupId'), _.get(actionItemGroup, 'GroupId'))) {                            
                            _.forEach(actionItemGrp.ActionItems, function (actionItm, index, array) {
                                if (_.isEqual(_.get(actionItm, 'Id'), _.get(actionItem, 'Id'))) {
                                    _.set(actionItem, "Status", "NS");
                                    _.set(actionItem, "DateRemoved", "");
                                    _.set(actionItem, "DateCompleted", "");
                                    $s.isEditingActionItem = true;
                                    $s.currentActionItem = _.cloneDeep(actionItem);
                                    $s.currentActionItemRef = _.cloneDeep(actionItem);
                                    $s.currentActionItemGroupRef = _.cloneDeep(actionItemGroup);
                                    $s.$applyAsync(array[index] = _.cloneDeep(actionItem));
                                    $s.onActionItemSave();
                                    $s.navigateToTabAfterActionItemSave("IP");                                    
                                }
                            });
                        }
                    });
                    
                }, function cancelActionItemUndoRemoval() {

                    log.info("The ActionItem removal was canceled");
                });
            };
          
           

            $s.onFarmGoalSave = function onFarmGoalSave(modalId){
                        $s.farmGoal = $s.currentFarmGoalText;
                      
                        $s.newFarmGoalData = {
                            farmId: MSF.activeHerd.farmId,
                            userId: $s.currentUser.PersonId,
                            goal: $s.currentFarmGoalText,
                            test: "TEST"
                        };

                        $s.updateFarmGoalAndPage(_.cloneDeep($s.newFarmGoalData));

                        $s.newFarmGoalData = {};
                        $s.currentFarmGoalText = "";
                        $s.toggleModal(modalId);
            };

            $s.onActionItemGroupSave = function onActionItemGroupSave(modalId){
                 var validationErrors = $s.validateActionItemGroup($s.currentActionItemGroup);
                        if (_.isEmpty(validationErrors)) {

                     

                            if (_.isEqual(_.get($s.currentActionItemGroup, 'ActionItemGroupKey'), "OTHER")) {
                                _.set($s.currentActionItemGroup, 'Description', _.get($s.currentActionItemGroup, 'ActionItemGroupKeyFreeText'));
                            } else {
                                _.set($s.currentActionItemGroup, 'Description', _.get(_.find($s.codeFileActionItemGroups, { code: _.get($s.currentActionItemGroup, 'ActionItemGroupKey') }), 'codeValue'));
                            }
                            $s.currentActionItemGroup = _.omit($s.currentActionItemGroup, 'ActionItemGroupKeyFreeText');

                            if (_.get(_.get($s.currentActionItemGroup, 'AssociatedMetrics'), 'length') > 0) {
                                _.set($s.currentActionItemGroup, 'AssociatedMetrics', _.map(_.get($s.currentActionItemGroup, 'AssociatedMetrics'), function (metricCode) {
                                    return { Metric: metricCode };
                                })

                                );
                            }
                            _.set($s.currentActionItemGroup, 'AssociatedMetricsDisplay', $s.getAssociatedMetricsStringList(_.get($s.currentActionItemGroup, 'AssociatedMetrics', []), "Metric", ","));

                             // need to add an empty action item to new group so that it shows up on the list , but first we need to make the 
                             // create Action Item Group call here and inside the return create the mostly empty action item , but with the returned GroupId and Status = "A"

                            if ($s.isEditingActionItemGroup) {

                                // update existing group 
                               
                                _.forEach($s.actionItemGroups, function (actionItemGroup, index, array) {
                                    if (_.isEqual(_.get(actionItemGroup, 'GroupId'), _.get($s.currentActionItemGroupRef, 'GroupId'))) {

                                        array[index] = _.cloneDeep($s.currentActionItemGroup);
                                    }
                                });

                                var groupId = _.get($s.currentActionItemGroup,'GroupId');

                                var updatedGroup = _.cloneDeep($s.currentActionItemGroup);

                                _.set(updatedGroup,'MetricsJson',JSON.stringify(_.get($s.currentActionItemGroup,'AssociatedMetrics')));
                               

                                api.updateActionItemGroup(groupId,updatedGroup
                                ,function(err,data){
                                    if (err) {
                                        console.log("Error:");
                                        console.log(err);
                                    }
                                });


                                $s.isEditingActionItemGroup = false;
                                $s.currentActionItemGroup = {};
                                $s.currentActionItemGroupRef = {};
                                  updateStatusSeparatedActionItemGroups();
                                $s.toggleModal(modalId);
                                $s.clearAllActionItemGroupValidationErrors();



                            } else {

                                var createGroup  = _.cloneDeep($s.currentActionItemGroup);

                                _.set(createGroup,'MetricsJson',JSON.stringify(_.get(createGroup,'AssociatedMetrics')));
                                
                                if(_.isEqual(_.get(createGroup,'AuditId'),0)){
                                    _.set(createGroup,"AuditId",null);
                                }else{
                                    _.set(createGroup,"AuditId",_.get(createGroup,'AuditId'));
                                }
                                    
                                _.set(createGroup,"HerdId",_.get($s.activeHerd,'herdId',_.get($s.activeFarm,'herds[0].herdId')));

                                api.createActionItemGroup(_.get($s.activeHerd,'herdId',_.get($s.activeFarm,'herds[0].herdId')),createGroup,function(err,data){
                                    if (err) {
                                        console.log("Error:");
                                        console.log(err);
                                    }

                                    var newGroupId = _.get(data,'[0].groupId');
                                    _.set($s.currentActionItemGroup,'GroupId',newGroupId);


                                    $s.actionItemGroups.push($s.currentActionItemGroup);


                                    $s.isEditingActionItemGroup = false;
                                    $s.currentActionItemGroup = {};
                                    $s.currentActionItemGroupRef = {};
                                      updateStatusSeparatedActionItemGroups();
                                    $s.toggleModal(modalId);
                                    $s.clearAllActionItemGroupValidationErrors();
                                    $s.navigateToTabAfterActionItemSave("NS");
                                });
                               

                            }

                                                
                        } else {
                            _.forEach(validationErrors, function (error) {
                                var controlId = _.get(error, 'controlId');
                                var controlErrorTextId = _.get(error, 'controlErrorTextId');
                                $(controlId).addClass('error');
                                $(controlErrorTextId).removeClass('dis-none');
                            });
                        }
            };

            $s.onActionItemSave = function onActionItemSave(modalId){
          
                var validationErrors = $s.validateActionItem($s.currentActionItem, $s.currentActionItemGroupRef);
                if (_.isEmpty(validationErrors) || _.isUndefined(modalId)) {

                    // flatten Person object and remove the property
                    if (!_.isUndefined(_.get($s.currentActionItem, "Person"))){
                        _.set($s.currentActionItem, 'PersonId', _.get($s.currentActionItem, 'Person.PersonId'));
                        _.set($s.currentActionItem, 'FirstName', _.get($s.currentActionItem, 'Person.FirstName'));
                        _.set($s.currentActionItem, 'LastName', _.get($s.currentActionItem, 'Person.LastName'));
                        _.set($s.currentActionItem, 'FullName', _.get($s.currentActionItem, 'Person.FullName'));

                        $s.currentActionItem = _.omit($s.currentActionItem, 'Person');
                    }

                     var actionItemStatus = _.get($s.currentActionItem,'Status',"");

                    if(!_.isEqual(actionItemStatus,"") && _.includes(["NS","IP"],actionItemStatus))
                    {
                        _.set($s.currentActionItem,'DateCompleted',"");                     
                    }
                
                    _.set($s.currentActionItem,'GroupId',_.get($s.currentActionItemGroupRef,'GroupId'));
                
                    


                    if ($s.isEditingActionItem) {

                     
                        let updatedActionItem = _.cloneDeep($s.currentActionItem);                        

                        if (!_.isDate(updatedActionItem.DateCompleted) || updatedActionItem.DateCompleted === "Invalid date") {
                            _.set(updatedActionItem, "DateCompleted", null);
                        }

                        if (!_.isDate(updatedActionItem.DateRemoved) || updatedActionItem.DateRemoved === "Invalid date") {
                            _.set(updatedActionItem, "DateRemoved", null);
                        }

                        api.updateActionItem(_.get(updatedActionItem, "Id"), updatedActionItem,
                            function doneUpdatingActionItem(err, data) {
                                if (err) {
                                    console.log("Error:");
                                    console.log(err);
                                }
                        });

                        
                        _.forEach($s.actionItemGroups,function(actionItemGroup,index,array){
                            if(_.isEqual(_.get(actionItemGroup,'GroupId'),_.get($s.currentActionItemGroupRef,'GroupId'))){

                                _.forEach(_.get(actionItemGroup,'ActionItems',[]),function(actionItem,actionItemIndex, actionItemArray){
                                    if(_.isEqual(_.get(actionItem,'Id'),_.get($s.currentActionItemRef,'Id'))){
                                        actionItemArray[actionItemIndex] = _.cloneDeep($s.currentActionItem);
                                    }
                                });

                                
                            }
                        });


                        $s.isEditingActionItem = false;
                        $s.currentActionItem = {};
                        $s.currentActionItemRef = {};
                        $s.currentActionItemGroupRef = {};
                        updateStatusSeparatedActionItemGroups();
                        $s.toggleModal(modalId);
                        $s.clearAllActionItemValidationErrors();
                        $s.navigateToTabAfterActionItemSave(actionItemStatus);



                    } else {
                         // CREATE -- will include inside callback up create api call.
                        var herdId = _.get($s.activeHerd, 'herdId', _.get($s.activeFarm, 'herds[0].herdId'));
                        var groupId = _.get($s.currentActionItemGroupRef, 'GroupId');
                        _.set($s.currentActionItem, 'FarmGoalJson', $s.farmGoal);
                        _.set($s.currentActionItem, 'DateCompleted', null);
                        _.set($s.currentActionItem, 'DateRemoved', null);
                        var createdActionItem = _.cloneDeep($s.currentActionItem);
                        api.createActionItem(herdId, groupId, createdActionItem,
                            function doneCreatingActionItem(err, data) {
                                if (err) {
                                    console.log("Error:");
                                    console.log(err);
                                }
                               
                                if (_.get(data, "length") > 0)
                                    _.set($s.currentActionItem, 'Id', _.get(data[0], "Id"));
                                _.forEach($s.actionItemGroups, function (actionItemGroup, index, array) {

                                    if (_.isEqual(_.get(actionItemGroup, 'GroupId'), _.get($s.currentActionItemGroupRef, 'GroupId'))) {
                                        actionItemGroup.ActionItems.push(_.cloneDeep($s.currentActionItem));
                                    }

                                });


                                $s.isEditingActionItem = false;
                                $s.currentActionItem = {};
                                $s.currentActionItemRef = {};
                                $s.currentActionItemGroupRef = {};
                                updateStatusSeparatedActionItemGroups();
                                $s.toggleModal(modalId);
                                $s.clearAllActionItemValidationErrors();
                                $s.navigateToTabAfterActionItemSave(actionItemStatus);
                            });
                    }
                   
                    
                } else {
                    _.forEach(validationErrors, function (error) {
                        var controlId = _.get(error, 'controlId');
                        var controlErrorTextId = _.get(error, 'controlErrorTextId');
                        $(controlId).addClass('error');
                        $(controlErrorTextId).removeClass('dis-none');
                    });
                }
            };

            $s.navigateToTabAfterActionItemSave = function(actionItemStatus){
                switch(actionItemStatus){
                    case "NS":
                    case "IP":
                        $('#myTab a[data-target="#active"]').tab('show');
                        break;
                    case "C":
                        $('#myTab a[data-target="#completed"]').tab('show');
                        break;
                    case "R":
                        $('#myTab a[data-target="#removed"]').tab('show');
                        break;

                }
            };

            

            function updateStatusSeparatedActionItemGroups() {               
                $s.activeActionItemGroups = _.cloneDeep(_.filter($s.actionItemGroups, function (aig) { return (aig.ActionItems.length == 0) || (aig.ActionItems.length > 0 && (_.some(aig.ActionItems, { Status: 'A' }) || _.some(aig.ActionItems, { Status: 'NS' }) || _.some(aig.ActionItems, { Status: 'IP' })) );}));
                $s.completedActionItemGroups = _.cloneDeep(_.filter($s.actionItemGroups, function (aig) { return aig.ActionItems.length > 0 && _.some(aig.ActionItems, { Status: 'C' }); }));
                $s.removedActionItemGroups = _.cloneDeep(_.filter($s.actionItemGroups, function (aig) { return aig.ActionItems.length > 0 && _.some(aig.ActionItems, { Status: 'R' }) }));
                $s.displayRemovedActionItemGroups = [];             
                // filter down action items in each group to only the status applicable
                _.forEach($s.activeActionItemGroups, function (actionItemGroup,index,array) {
                    _.set(actionItemGroup, "ActionItems", _.sortByOrder(_.filter(actionItemGroup.ActionItems, function (ai) { return ai.Status === 'A' || ai.Status === 'IP' || ai.Status === 'NS'; }),function(actionItem){return _.get(actionItem,'DueDate');},["asc"]));
                    array[index] =  actionItemGroup;
                });

                _.forEach($s.completedActionItemGroups, function (completedActionItemGroup,index,array) {
                    _.set(completedActionItemGroup, "ActionItems", _.sortByOrder(_.filter(completedActionItemGroup.ActionItems, function (ai) { return ai.Status === 'C'; }),function(actionItem){return _.get(actionItem,'DateCompleted');},["desc"]));
                    array[index] = completedActionItemGroup; 
                });

                _.forEach($s.removedActionItemGroups, function (removedActionItemGroup,index,array) {                    
                    _.set(removedActionItemGroup, "ActionItems", _.sortByOrder(_.filter(removedActionItemGroup.ActionItems, function (ai) { return ai.Status === 'R'; }),function(actionItem){return _.get(actionItem,'DueDate');},["desc"]));
                    
 
                    _.forEach(removedActionItemGroup.ActionItems, function (ai) {
                        _.set(ai, "ProfitDriver", removedActionItemGroup.Description);

                        var displayRemovedActionItemGroupItem = _.extend(
                                                                           {},
                                                                           _.cloneDeep(ai),
                                                                           {ActionItemGroup: removedActionItemGroup},
                                                                           {ActionItem: ai},
                                                                           {ProfitDriver: _.get(removedActionItemGroup,'Description')}
                                                                 );
                        $s.displayRemovedActionItemGroups.push(displayRemovedActionItemGroupItem);

                    });
                    array[index] = removedActionItemGroup;
                });

               $s.displayRemovedActionItemGroups = _.sortByOrder($s.displayRemovedActionItemGroups,function(actionItem){return _.get(actionItem,'DueDate');},["desc"]);
                
            }

            $s.onCancel = function onCancel(actionDataType, modalId) {
                switch (actionDataType) {
                    case "ACTION_ITEM_GROUP":
                        $s.isEditingActionItemGroup = false;
                        $s.currentActionItemGroup = {};
                        $s.currentActionItemGroupRef = {};
                        $s.clearAllActionItemGroupValidationErrors();
                        break;
                    case "ACTION_ITEM":
                        $s.isEditingActionItem = false;
                        $s.currentActionItem = {};
                        $s.currentActionItemRef = {};
                        $s.currentActionItemGroupRef = {};
                        $s.clearAllActionItemValidationErrors();
                        break;
                    default:
                        break;
                }
                $s.toggleModal(modalId);
            };

            

            $s.onDelete = function onDelete(actionDataType, modalId) {
                switch (actionDataType) {
                    case "ACTION_ITEM_GROUP":

                        MSF.confirm({
                            title: 'Remove',
                            messageHeader: "Profit Driver: " + _.get($s.currentActionItemGroup, 'Description', ""),
                            message: "Are you sure you want to remove this Profit Driver? Removing the Profit Driver will remove all Action Items under it.",
                            confirm: {
                                className: 'danger',
                                icon: 'trash',
                                text: "Remove"
                            }
                        }, function confirmActionItemGroupRemoval() {

                            $s.$applyAsync($s.actionItemGroups = _.reject($s.actionItemGroups, $s.currentActionItemGroupRef));

                            $s.isEditingActionItemGroup = false;
                            $s.currentActionItemGroup = {};
                            $s.currentActionItemGroupRef = {};

                            $s.toggleModal(modalId);

                        }, function cancelActionItemGroupRemoval() {

                            log.info("The ActionItemGroup removal was canceled");
                        });

                        break;
                    case "ACTION_ITEM":


                        var existingActionItem = _.find(_.get($s.currentActionItemGroupRef, 'ActionItems', []), { Description: _.get($s.currentActionItemRef, 'Description') });

                        MSF.confirm({
                            title: 'Remove',
                            messageHeader: "Action Item: " + _.get(existingActionItem, "Description", ""),
                            message: "Are you sure you want to remove this Action Item?",
                            confirm: {
                                className: 'danger',
                                icon: 'trash',
                                text: "Remove"
                            }
                        }, function confirmActionItemRemoval() {

                            var actionItemGroupActionItems = _.get($s.currentActionItemGroupRef, 'ActionItems', []);

                            _.forEach($s.actionItemGroups, function (actionItemGroup) {
                                if (_.isEqual(_.get(actionItemGroup, 'Description'), _.get($s.currentActionItemGroupRef, 'Description'))) {

                                    $s.$applyAsync(actionItemGroup.ActionItems = _.reject(actionItemGroup.ActionItems, $s.currentActionItemRef));

                                }
                            });

                            $s.isEditingActionItem = false;
                            $s.currentActionItem = {};
                            $s.currentActionItemRef = {};
                            $s.currentActionItemGroupRef = {};

                            $s.toggleModal(modalId);

                        }, function cancelActionItemRemoval() {

                            log.info("The ActionItem removal was canceled");
                        });

                        break;
                    default:
                        break;
                }

            };

           

            $s.toggleModal = function (modalId) {                
                var modal = $('#' + modalId);
                if (_.isUndefined(modal[0]) || !modal[0]) return;

                if (modal.is(':visible')) {
                    modal.css("display", "none");
                } else {
                    modal.css("display", "block");
                }
            };


            $s.clearAllActionItemGroupValidationErrors = function clearAllActionItemGroupValidationErrors() {
                $("#modalActionItemGroupKey").removeClass('error');
                $("#errorInputActionItemGroupKey").addClass('dis-none');

                $("#modalActionItemGroupKeyFreeText").removeClass('error');
                $("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');

                $("#modalActionItemGroupAssociatedMetric").removeClass('error');
                $("#errorInputAssociatedMetricText").addClass('dis-none');

                $s.actionItemGroupKeyErrorText = "";
                $s.actionItemGroupKeyFreeTextErrorText = "";


            };

            $s.clearAllActionItemValidationErrors = function clearAllActionItemValidationErrors() {
                $("#modalActionItemDescription").removeClass('error');
                $("#errorInputDescriptionText").addClass('dis-none');

                $("#modalActionItemAssignedTo").removeClass('error');
                $("#errorInputAssignedToText").addClass('dis-none');

                $("#modalActionItemDueDate").removeClass('error');
                $("#errorInputDueDateText").addClass('dis-none');

                $("#modalActionItemStatus").removeClass('error');
                $("#errorInputStatusText").addClass('dis-none');

                $("#modalActionItemCompletionDate").removeClass('error');
                $("#errorInputDateCompletedText").addClass('dis-none');

                $s.actionItemGroupKeyErrorText = "";
                $s.actionItemGroupKeyFreeTextErrorText = "";


            };

            $s.validateActionItem = function validateActionItem(actionItem, actionItemGroup) {
                var invalidErrorIds = [];


                //--------------------------------------------------------------
                // Description(What To Do) Validation
                //--------------------------------------------------------------
                var descriptionControlId = "#modalActionItemDescription";
                var descriptionErrorTextId = "#errorInputDescriptionText";
                var description = _.trim(_.get(actionItem, 'Description'));

                if (_.isEmpty(description)) {
                    invalidErrorIds.push({ controlId: descriptionControlId, controlErrorTextId: descriptionErrorTextId });
                }
                //--------------------------------------------------------------

                //--------------------------------------------------------------
                // AssignedTo Validation
                //--------------------------------------------------------------
                var assignedToControlId = "#modalActionItemAssignedTo";
                var assignedToErrorTextId = "#errorInputAssignedToText";
                var assignedTo = _.get(actionItem, 'Person', {});

                if (_.isEmpty(assignedTo)) {
                    invalidErrorIds.push({ controlId: assignedToControlId, controlErrorTextId: assignedToErrorTextId });
                }

                //--------------------------------------------------------------


                //--------------------------------------------------------------
                // DueDate Validation
                //--------------------------------------------------------------

                var dueDateControlId = "#modalActionItemDueDate";
                var dueDateErrorTextId = "#errorInputDueDateText";
                var dueDate = _.get(actionItem, 'DueDate');

                if (_.isUndefined(dueDate) || _.isEqual(dueDate, "") || moment(dueDate).toDate() <= moment().toDate()) {
                    invalidErrorIds.push({ controlId: dueDateControlId, controlErrorTextId: dueDateErrorTextId });
                }

                //--------------------------------------------------------------

                
                //--------------------------------------------------------------
                // Date Completed  Validation
                //--------------------------------------------------------------

                var dateCompletedControlId = "#modalActionItemCompletionDate";
                var dateCompletedErrorTextId = "#errorInputDateCompletedText";
                var status = _.get(actionItem,'Status');
                var dateCompleted = _.get(actionItem, 'DateCompleted');

                if ((_.isEqual(status,"C")) && (_.isUndefined(dateCompleted) || _.isEqual(dateCompleted, "") || moment(moment(dateCompleted).format("M/D/YYYY")).toDate() > moment(moment().format("M/D/YYYY")).toDate()) ) {
                    invalidErrorIds.push({ controlId: dateCompletedControlId, controlErrorTextId: dateCompletedErrorTextId });
                }

                //--------------------------------------------------------------

                return invalidErrorIds;
            };

            $s.validateActionItemGroup = function validActionItemGroup(actionItemGroup) {
                var invalidErrorIds = [];
                //--------------------------------------------------------------
                // Group Key Validation
                //--------------------------------------------------------------
                var isFreeTextGroupKey = false;
                var groupKeyInputId = "#modalActionItemGroupKey";
                var groupKeyErrorTextId = "#errorInputActionItemGroupKey";
                var chosenGroupKey = _.get(actionItemGroup, 'ActionItemGroupKey');

                if(_.isEqual(chosenGroupKey,"OTHER")){
                    chosenGroupKey = _.get(actionItemGroup, 'ActionItemGroupKeyFreeText');
                    groupKeyInputId = "#modalActionItemGroupKeyFreeText";
                    groupKeyErrorTextId = "#errorInputActionItemGroupKeyFreeText";
                    var isFreeTextGroupKey = true;
                }
                var refGroupKey = _.get($s.currentActionItemGroupRef, 'ActionItemGroupKey');

                // no group key was chosen
                if (_.isEmpty(chosenGroupKey)) {
                    if (isFreeTextGroupKey) {
                        $s.actionItemGroupKeyFreeTextErrorText = "Required field.";
                    } else {
                        $s.actionItemGroupKeyErrorText = "Required field.";
                    }

                    invalidErrorIds.push({ controlId: groupKeyInputId, controlErrorTextId: groupKeyErrorTextId });
                }

                //--------------------------------------------------------------

                //--------------------------------------------------------------
                // Associated Metrics
                //--------------------------------------------------------------

                var associatedMetricsControlId = "#modalActionItemGroupAssociatedMetric";
                var associatedMetricsErrorTextId = "#errorInputAssociatedMetricText";

                var associatedMetrics = _.get(actionItemGroup, 'AssociatedMetrics', []);
                if (_.isEqual(_.get(associatedMetrics, 'length'), 0)) {
                    invalidErrorIds.push({ controlId: associatedMetricsControlId, controlErrorTextId: associatedMetricsErrorTextId });
                }

                //--------------------------------------------------------------
                return invalidErrorIds;
            };

            $s.onActionItemGroupKeyChange = function onActionItemGroupKeyChange() {
              
                var hadError = $("#modalActionItemGroupKey").hasClass("error");

                if (hadError) {
                    $("#modalActionItemGroupKey").removeClass('error');
                    $("#errorInputActionItemGroupKey").addClass('dis-none');
                }


                if(!_.isEqual(_.get($s.currentActionItemGroup,'ActionItemGroupKey'),"OTHER")){
                    var freeTextHadError = $("#modalActionItemGroupKeyFreeText").hasClass("error");

                    if (freeTextHadError) {
                        $("#modalActionItemGroupKeyFreeText").removeClass('error');
                        $("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');
                    }
                
                }

               
                return true;
            };

            $s.onActionItemGroupKeyFreeTextChange = function onActionItemGroupKeyFreeTextChange() {
                var hadError = $("#modalActionItemGroupKeyFreeText").hasClass("error");

                if (hadError) {
                    $("#modalActionItemGroupKeyFreeText").removeClass('error');
                    $("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');
                }
            };
            $s.onActionItemGroupAssociatedMetricsChange = function onActionItemGroupAssociatedMetricsChange() {
                var hadError = $("#modalActionItemGroupAssociatedMetric").hasClass("error");

                if (hadError) {
                    $("#modalActionItemGroupAssociatedMetric").removeClass('error');
                    $("#errorInputAssociatedMetricText").addClass('dis-none');

                }
            };

            $s.onActionItemDescriptionChange = function onActionItemDescriptionChange() {
                var hadError = $("#modalActionItemDescription").hasClass("error");

                if (hadError) {
                    $("#modalActionItemDescription").removeClass('error');
                    $("#errorInputDescriptionText").addClass('dis-none');

                }
            };

            $s.onAssignedToChange = function (val) {
                var hadError = $("#modalActionItemAssignedTo").hasClass("error");

                if (hadError) {
                    $("#modalActionItemAssignedTo").removeClass('error');
                    $("#errorInputAssignedToText").addClass('dis-none');
                }
            };


            $s.onDueDateChange = function onDueDateChange() {
                var hadError = $("#modalActionItemDueDate").hasClass("error");

                if (hadError) {
                    $("#modalActionItemDueDate").removeClass('error');
                    $("#errorInputDueDateText").addClass('dis-none');
                }
            };

            $s.onStatusChange = function onStatusChange() {
                var hadError = $("#modalActionItemStatus").hasClass("error");

                if (hadError) {
                    $("#modalActionItemStatus").removeClass('error');
                    $("#errorInputStatusText").addClass('dis-none');
                }

                var dateCompletedHadError = $("#modalActionItemCompletionDate").hasClass("error");

                if (dateCompletedHadError) {
                    $("#modalActionItemCompletionDate").removeClass('error');
                    $("#errorInputDateCompletedText").addClass('dis-none');
                }

                if(_.isEqual(_.get($s.currentActionItem,'Status'),"C") && (_.isEqual(_.get($s.currentActionItem,'DateCompleted'),"") || _.isNull($s.currentActionItem,'DateCompleted'))  ){
                    _.set($s.currentActionItem,'DateCompleted',moment().toDate());
                }

            };

            $s.onDateCompletedChange = function onDateCompletedChange() {
                var hadError = $("#modalActionItemCompletionDate").hasClass("error");

                if (hadError) {
                    $("#modalActionItemCompletionDate").removeClass('error');
                    $("#errorInputDateCompletedText").addClass('dis-none');
                }
            };


            $s.cancel = function cancel() {
                MSF.loadPage('FarmGoalManagement');
            };

            $s.formatShortDateString = function formatShortDateString(date) {
                if (!date) return "";
                var stringDate = null;
                if (!_.isNull(date) && !_.isUndefined(date)) {
                    if (_.isString(date) && date.indexOf("T") > -1) {

                    }
                    
                    stringDate = moment(date).format($s.dateFormat);
                }
                return stringDate;
            }

            $s.getStatusDisplay = function getStatusDisplay(status) {
                switch (status) {
                    case "NS": return "Not Started"
                    case "IP": return "In Progress"
                    case "C": return "Completed";
                    case "R": return "Removed";
                }
            }

            
           

            function loadFarmGoalData() {
                var farmId = $s.farmId;
               
                async.auto({
                    getFarmGoal: function (done) {
                        api.getFarmGoalMgmt(farmId,
                            function (err, data) {
                                if (err) {
                                    log.error({ error: err }, 'Error getting farm goal data');
                                }

                                return done(err, data);
                            });
                    }

                }, function finishedGettingFarmGoal(err, data) {
                    if (err) {
                        // --- debugging
                        alert(err);
                    }
                });
            }

            $s.updateFarmGoalAndPage = function updateFarmGoalAndPage(farmGoalData) {
                async.auto({
                    updateFarmGoal: function (done) {

                        $s.loading = true;

                        api.updateFarmGoalMgmt(_.extend({}, farmGoalData),
                            function (err, data) {
                                if (err) {
                                    log.error({ error: err }, 'Error updating farm goal management data');
                                }

                                return done(err, data);
                            });
                    }

                }, function finishedUpdatingFarmGoal(err, data) {
                    if (err) {
                        alert(err);
                    }
                });
            }

           $s.loadReportData =  function loadReportData() {
                const loadReportDataPromise = $q.defer();
                var farmId = _.get($s.activeHerd,'farmId',_.get($s.activeFarm,'farmId'));
                var herdId = _.get($s.activeHerd,'herdId',_.get($s.activeFarm,'herds[0].herdId'))

                async.auto({

                    getFarmGoal: function(done){
                        perfMetricSvc.startTiming("Page:FarmGoalManagementGetFarmGoalMgmt:Request");
                        api.getFarmGoalMgmt(farmId, $s.performanceContext,
                            function (err, data) {
                                perfMetricSvc.endTiming("page","Page:FarmGoalManagementGetFarmGoalMgmt:Request", $s.performanceContext);
                                if (err) {
                                    log.error({ error: err }, 'Error getting farm goal data');
                                }
                                   
                                 $s.farmGoal = _.get(data,'[0].FarmGoal');
                                return done(err, data);
                            });

                    },
                    getActionItemGroupData: function (done) {
                        perfMetricSvc.startTiming("Page:FarmGoalManagementGetActionItemGroups:Request");
                        api.getAllActionItemsByHerdId(herdId, $s.performanceContext,
                            function (err, data) {
                                perfMetricSvc.endTiming("page","Page:FarmGoalManagementGetActionItemGroups:Request", $s.performanceContext);
                                if (err) {
                                    log.error({ error: err }, 'Error getting action item groups data');
                                }

                                if (data.length > 0) {
                                    if (data[0].actionItemDetailsJson) {
                                        deconstructActionItemGroupsAndItems(JSON.parse(data[0].actionItemDetailsJson));
                                    }
                                }
                                $s.pageLoading = false;
                                return done(err, data);
                            });
                    }

                }, function finishedGettingReportData(err, data) {
                    if (err) {
                        // --- debugging
                        console.log(err);
                    }
                    $s.pageLoading = false;
                    loadReportDataPromise.resolve();

                });
                return loadReportDataPromise.promise;
            }
          
          

            $s.validate = function validate() {
                var validActionItemGroups = true;
                var validActionItems = true;

                if (_.get($s.actionItemGroups, 'length') == 0) {
                    $s.currentTopAnchor = "actionItemGroupSection";
                    validActionItemGroups = false;
                }

                var allActionItems = _.pluck($s.actionItemGroups, 'ActionItems');
                var anActionItemExists = false;
                anActionItemExists = _.some(allActionItems, function (actionItemArray) {
                    if (_.get(actionItemArray, 'length') > 0) {
                        return true;
                    }
                });
                if (!anActionItemExists) {
                    $s.currentTopAnchor = "actionItemGroupSection";
                    validActionItems = false;
                }



                return validActionItemGroups && validActionItems;
            }

            function deconstructActionItemGroupsAndItems(actionItemGroups) {
                if (!actionItemGroups) {
                    return;
                }
                

                _.forEach(actionItemGroups, function (actionItemGroup,groupIndex,groupsArray) {

                    actionItemGroup = _.extend(_.cloneDeep($s.actionItemGroupTmpl),actionItemGroup);

                    _.set(actionItemGroup, 'AssociatedMetricsDisplay',                        
                        $s.getAssociatedMetricsStringList(_.get(actionItemGroup, 'MetricsJson', []), "Metric", ",")
                    );
                    _.set(actionItemGroup,'AssociatedMetrics',_.get(actionItemGroup,'MetricsJson'));

                
                    _.set(actionItemGroup, 'Description', _.get(actionItemGroup,'GroupDesc'));
                    actionItemGroup = _.omit(actionItemGroup,["GroupDesc"]);
                    _.set(actionItemGroup, 'ActionItems', actionItemGroup.ActionItemJson || []);
                  

                    _.forEach(actionItemGroup.ActionItems, function (actionItem,itemIndex, itemArray) {

                        actionItem = _.extend(_.cloneDeep($s.actionItemTmpl),actionItem);

                        var dueDate = _.get(actionItem,'DueDate',"");
                        if(!_.isEqual(dueDate,"")){
                            dueDate = moment(dueDate).toDate();
                            _.set(actionItem,'DueDate',dueDate)  
                        }

                        var dateCompleted = _.get(actionItem,'DateCompleted',"");
                        if(!_.isEqual(dateCompleted,"")){
                            dateCompleted = moment(dateCompleted).toDate();
                            _.set(actionItem,'DateCompleted',dateCompleted)  
                        }

                        var removedDate = _.get(actionItem,'RemovedDate',"");
                        if(!_.isEqual(removedDate,"")){
                            removedDate = moment(removedDate).toDate();
                            _.set(actionItem,'RemovedDate',removedDate)  
                        }
                       
                        var auditPublishedOn = _.get(actionItem,'PublishedOn',"");
                        if(!_.isEqual(auditPublishedOn,"")){
                            auditPublishedOn = moment(auditPublishedOn);
                        }

                          
                           if(_.get(actionItem,'AuditId')> 0){
                            _.set(actionItem,'F360Link',"#/f360/"+_.get(actionItem,'AuditId',null)); 
                            _.set(actionItem,'F360LinkText',auditPublishedOn.format("MMM YYYY"));
                         }
                       

                        itemArray[itemIndex] = _.cloneDeep(actionItem);

                    });

                    groupsArray[groupIndex] = _.omit(actionItemGroup,["MetricsJson","GroupDesc","ActionItemJson"]);
                });
                $s.actionItemGroups = actionItemGroups;
                updateStatusSeparatedActionItemGroups();
               
            }

           $s.clearReportData = function clearReportData(){
                $s.farmGoal = "";
                $s.actionItemGroups = [];
                $s.activeActionItemGroups = [];
                $s.completedActionItemGroups = [];
                $s.removedActionItemGroups = [];
                $s.actionItems = [];
           }


            $s.$on("$destroy", function () {
                if (deregOnHerdChange) {
                    deregOnHerdChange();
                }
                $s.performanceContext = null;
             });

             
         

            MSF.ready(function whenMsfReady() {
                $s.performanceContext = perfContextSvc.createPerformanceContext(_.get($s.activeHerd,'herdId', null));
                perfMetricSvc.startTiming("Page:FarmGoalManagement:Render");
                perfMetricSvc.startTiming("Page:FarmGoalManagement:Build");
                $s.hasUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',$s.updatePermissionCode));
             
                // if farmId on state.params is an empty string then we are adding a new farm
                if (_.isEqual(MSF.state.params.farmId, "")) {
                    $s.isEditing = false;
                } else {
                    $s.farmId = Number(MSF.state.params.farmId);
                }

                $s.codeFile = _.cloneDeep(_.get(MSF, 'lists.codeFile', []));

                try {
                    var actionItemGroupTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile, { codeType: "JSONTEMPLATES", code: "TMPLF360ACTITMGRP" }), 'detailsJson'));
                    var maxActionItemGroupTemplateApiVer = _.max(
                        _.map(actionItemGroupTemplateDetailsJsonArray, function (actionItemGroupTmplDetailsVersion) {
                            var apiVerNumStr = _.get(actionItemGroupTmplDetailsVersion, 'apiVersion').replace("v", "");
                            return parseFloat(apiVerNumStr);
                        })
                    );

                    $s.actionItemGroupTmpl = _.get(_.find(actionItemGroupTemplateDetailsJsonArray, { apiVersion: `v${maxActionItemGroupTemplateApiVer}` }), 'template');

                } catch (e) {
                    log.info("Review Draft Page: Action Item Group Template failed to be acquired from Code File or failed to be parsed");
                }

                try {
                    var actionItemTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile, { codeType: "JSONTEMPLATES", code: "TMPLF360ACTITM" }), 'detailsJson'));
                    var maxActionItemTemplateApiVer = _.max(
                        _.map(actionItemTemplateDetailsJsonArray, function (actionItemTmplDetailsVersion) {
                            var apiVerNumStr = _.get(actionItemTmplDetailsVersion, 'apiVersion').replace("v", "");
                            return parseFloat(apiVerNumStr);
                        })
                    );

                    $s.actionItemTmpl = _.get(_.find(actionItemTemplateDetailsJsonArray, { apiVersion: `v${maxActionItemTemplateApiVer}` }), 'template');

                } catch (e) {
                    log.info("Review Draft: Action Item Group Template failed to be acquired from Code File or failed to be parsed");
                }

               
                $s.codeFileActionItemGroups = _.filter($s.codeFile, { codeType: "ACTIONITEMGROUP" });

                $s.codeFileActionItemGroupMetrics = _.filter($s.codeFile, { codeType: "ACTIONITEMMETRIC" });

                $s.activeFarm = _.extend({}, MSF.getActiveFarm());

                $s.currentUser = MSF.cookies.user;
              

                $s.people = _.map(_.filter(_.get(MSF, 'lists.personActiveFarmAdmins', []), { farmId: _.get($s.activeFarm, 'farmId') }), function (farmAdmin) {
                   return {
                       FarmId:    _.get(farmAdmin, 'farmId'),
                       PersonId:  _.get(farmAdmin, 'personId'),
                       FirstName: _.get(farmAdmin, 'firstName'),
                       LastName:  _.get(farmAdmin, 'lastName'),
                       FullName:  _.get(farmAdmin, 'fullName')

                   }
                });

                $s.actionItemStatuses = _.filter($s.codeFile,{codeType: "ACTIONITEMSTATUS" });

                $s.dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();

               
                $s.loadReportData().then(() => {
                    perfMetricSvc.endTiming("page","Page:FarmGoalManagement:Build", $s.performanceContext);
                    perfMetricSvc.markPageReady("Page:FarmGoalManagement:Render", $s.performanceContext);
                });

               deregOnHerdChange = $s.$on('herd:changed', function(){
                    perfMetricSvc.startTiming("Page:FarmGoalManagementOnHerdChange:Render");
                    perfMetricSvc.startTiming("Page:FarmGoalManagementOnHerdChange:Build");
                    $s.pageLoading = true;
                    $s.clearReportData();
                    $s.activeHerd = angular.copy(MSF.getActiveHerd());
                    $s.activeFarm = _.extend({}, MSF.getActiveFarm());
                    $s.people     = _.map(_.filter(_.get(MSF, 'lists.personActiveFarmAdmins', []), { farmId: _.get($s.activeFarm, 'farmId') }), function (farmAdmin) {
                        return {
                            FarmId:    _.get(farmAdmin, 'farmId'),
                            PersonId:  _.get(farmAdmin, 'personId'),
                            FirstName: _.get(farmAdmin, 'firstName'),
                            LastName:  _.get(farmAdmin, 'lastName'),
                            FullName:  _.get(farmAdmin, 'fullName')
     
                        }
                     });
                     // we check here for update permission because a user may have a different role (therefore permissions) for different farms.
                     $s.hasUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',$s.updatePermissionCode));
                     
                     $s.dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();
                     $s.performanceContext = perfContextSvc.createPerformanceContext(_.get($s.activeHerd,'herdId', null));
                     $s.loadReportData().then(() => {
                        perfMetricSvc.endTiming("page","Page:FarmGoalManagementOnHerdChange:Build", $s.performanceContext);
                        perfMetricSvc.markPageReady("Page:FarmGoalManagementOnHerdChange:Render", $s.performanceContext);
                    });
                });
                $s.territoryManager = MSF.getActiveFarmTerritoryManager();
            });

        }
    ]);
}) ();
